import { v4 as uuidv4 } from 'uuid';

export const aboutData = [
  {
    id: uuidv4(),
    activeFilter: ['short'],
    categoryTitle: 'short',
    aboutVersionTop: 'Hello! My name is Abdul Farhan. I am a',
    aboutVersionSpan: 'Full-stack Web Developer',
    aboutVersionBottom:
      ' based in Vancouver, BC. I have a serious passion for creating interactive web based applications that makes a difference to the lives of those around me.',
    aboutVersionBottomTwo:
      "When I'm not coding, you'll find me gaming, playing sports or experimenting with YouTube food recipes.",
    listItemLink: 'about-container__profile-resume-link',
    listItemHref:
      'https://drive.google.com/uc?id=1rQxh4LdOqxDb8I-5t1eqM9AG3mdzGqXq&export=download',
    target: '_blank',
    rel: 'noopener noreferrer',
  },
  {
    id: uuidv4(),
    activeFilter: ['long'],
    categoryTitle: 'long',
    aboutVersionTop: 'Hello! My name is Abdul Farhan. I am a',
    aboutVersionSpan: 'Full-stack Web Developer',
    aboutVersionBottom:
      'based in Vancouver BC, who is passionate about building user-friendly, easy-to-use single page applications, that makes a difference to the lives of those around me. I like to explore new trends, learn new technologies, and document my journey and career as a developer in tech.',
    aboutVersionBottomTwo:
      "I have a diploma in Information and Communication Technology Management, and a diploma in Web Development. Apart from working on personal projects, I always find time to contribute to Open Source projects to be more involved in the community. When I'm not coding, you'll find me gaming, playing sports or experimenting with YouTube food recipes.",
    listItemLink: 'about-container__profile-resume-link',
    listItemHref:
      'https://drive.google.com/uc?id=1rQxh4LdOqxDb8I-5t1eqM9AG3mdzGqXq&export=download',
    target: '_blank',
    rel: 'noopener noreferrer',
  },
  {
    id: uuidv4(),
    activeFilter: ['third'],
    categoryTitle: 'third',
    aboutVersionTop: 'Abdul is a',
    aboutVersionSpan: 'Full-stack Web Developer',
    aboutVersionBottom:
      'based in Vancouver BC, who is passionate about building user-friendly, easy-to-use single page applications, that makes a difference to the lives of those around him. He likes to explore new trends, learn new technologies, and document his journey and career as a developer in tech.',
    aboutVersionBottomTwo:
      "He has a diploma in Information and Communication Technology Management, and a diploma in Web Development. Apart from working on personal projects, Abdul always finds time to contribute to Open Source projects to be more involved in the community. When he's not coding, you'll find him gaming, playing sports or experimenting with YouTube food recipes.",
    listItemLink: 'about-container__profile-resume-link',
    listItemHref:
      'https://drive.google.com/uc?id=1rQxh4LdOqxDb8I-5t1eqM9AG3mdzGqXq&export=download',
    target: '_blank',
    rel: 'noopener noreferrer',
  },
];
